import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Me</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            I'm a passionate web developer with experience in creating modern, responsive websites.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="w-80 h-80 mx-auto bg-gray-200 rounded-full overflow-hidden shadow-xl">
              <img 
                src="https://i.ibb.co.com/HLBKBVX1/IMG-0074-2.jpg" 
                alt="Tahsin Sikder - Web Developer"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              I will <span className="text-primary">Design</span> & <span className="text-primary">Develop</span> the best websites
            </h3>
            <p className="text-gray-600 mb-6">
             Hi, I’m Tahsin, a passionate MERN Stack Developer. I recently completed a MERN Stack bootcamp organized by ProgrammingHero and I’m actively seeking an internship or full-time opportunity where I can apply my skills and continue growing as a software engineer.

            </p>
            
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;